module.exports = __webpack_public_path__ + "img/mail-blue.19627e6c.svg";